import { theme } from '../styles';
import { isEmUnits, isPercentUnits, isPxUnits, isRemUnits, isViewHeightUnits, isViewWidthUnits } from './regExp';

type MediaQuery = {
  breakpoint: number;
  cssProp: string;
  cssValue: number | string;
};

const pxToRem = (pxValue: number | string) => {
  if (typeof pxValue === 'string' && /^-?\d*px$/.test(pxValue)) {
    pxValue.replace('px', '');
  }
  return Number(pxValue) ? `${Math.round((Number(pxValue) / 16) * 100_000) / 100_000}rem` : 0;
};
export const validateSpacingUnits = (value: number | string) => {
  if (typeof value === 'number') {
    return `${pxToRem(value)}`;
  }

  if (
    typeof value === 'string' &&
    (isPxUnits.test(value) ||
      isRemUnits.test(value) ||
      isEmUnits.test(value) ||
      isPercentUnits.test(value) ||
      isViewHeightUnits.test(value) ||
      isViewWidthUnits.test(value) ||
      value === 'auto' ||
      value === 'none')
  ) {
    return value;
  }
  return 0;
};

export const createSpacingMediaQuery = ({ breakpoint, cssProp, cssValue }: MediaQuery) => {
  if (breakpoint) {
    return `@media screen and (min-width: ${breakpoint}px) {
      ${cssProp}: ${validateSpacingUnits(cssValue)};
    }`;
  }
  return `${cssProp}: ${validateSpacingUnits(cssValue)}`;
};

export const createGridMediaQuery = ({ breakpoint, cssProp, cssValue }: MediaQuery) => {
  if (breakpoint) {
    // added !important because of the Grid component
    return `@media screen and (min-width: ${breakpoint}px) {
      ${cssProp}: ${validateSpacingUnits(cssValue)} !important;
    }`;
  }
  return `${cssProp}: ${validateSpacingUnits(cssValue)} !important`;
};

export const createGeneralMediaQuery = ({ breakpoint, cssProp, cssValue }: MediaQuery) => {
  // cssValue can be a non numeric string, as 'row | column' for 'flex-direction'
  if (breakpoint) {
    return `@media screen and (min-width: ${breakpoint}px) {
      ${cssProp}: ${cssValue};
    }`;
  }
  return `${cssProp}: ${cssValue}`;
};

export const mediaQueriesArray = (cssProp: string, cssValues: any[], createMediaQuery: any) => {
  const media: any = [];
  cssValues.forEach((value: number | string, idx: number) => {
    if (value !== undefined) {
      media.push(createMediaQuery({ breakpoint: theme.breakpoints[idx], cssProp, cssValue: value }));
    }
  });
  return media.length > 0 ? media.join(';') : null;
};
